var map = {
	"./en.ts": [
		"./public/locales/en.ts",
		4656
	],
	"./id.ts": [
		"./public/locales/id.ts",
		9282
	],
	"./ms.ts": [
		"./public/locales/ms.ts",
		6325
	],
	"./th.ts": [
		"./public/locales/th.ts",
		3741
	],
	"./vi.ts": [
		"./public/locales/vi.ts",
		6500
	],
	"./zh-hant-tw.ts": [
		"./public/locales/zh-hant-tw.ts",
		2107
	],
	"./zh.ts": [
		"./public/locales/zh.ts",
		1400
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./public/locales lazy recursive ^\\.\\/.*\\.ts$";
module.exports = webpackAsyncContext;